import _ from 'underscore'
import $ from 'jquery'

import {
    formatParsedDate,
    MobileDevice,
} from 'util/twistle'

import ContactList from 'app/collections/contact_list'

import { isHandheld } from 'util/breakpoints'
const Mustache = require("mustache");

// jquery-specific utility functions
(function($) {

    $.fn.checked = function(value) {
        if(value === true || value === false) {
            // Set the value of the checkbox
            $(this).each(function() {
                this.checked = value;
            });

        }
        else if(value === undefined || value === 'toggle') {

            // Toggle the checkbox
            $(this).each(function() {
                this.checked = !this.checked;
            });

        }

    };


    $.fn.reverse = [].reverse;

    $.fn.hoverClass = function(value, preventBubble) {
        if (App && App.isTouch()) {
            return this;
        }

        return this.hover(function(evt) {
            $(this).addClass(value);
            if(preventBubble) {
                evt.stopPropagation();
            }
        }, function(evt) {
            $(this).removeClass(value);
            if(preventBubble) {
                evt.stopPropagation();
            }
        });


    };

    $.fn.autoCapField = function(){

        return this.each(function(){
            var $this = $(this),
                initialVal = $this.val();

            $this.bind("keyup.twistleAutoCapField", function(evt){
                var $this = $(this),
                    txt = $this.val(),
                    beenCapped = $this.data("twistleAutocapitalizeComplete"),
                    autoCapSettingOff = $this.prop("autocapitalize") === "off";

                if(!beenCapped && !autoCapSettingOff){
                    var replacement = txt.toLowerCase().replace(/\b([a-z])/g, function (_, initial) {
                        return initial.toUpperCase();
                    });
                    if(replacement !== txt){
                        $this.val(replacement);
                        $this.data("twistleAutocapitalizeComplete", true);
                    }
                }

                if(initialVal.length > 0 && txt.length === 0){
                    // if they clear out the field, reset once
                    initialVal = "";
                    $this.data("twistleAutocapitalizeComplete", false);
                }
            });


            if (initialVal && initialVal.length > 0){
                $this.trigger("keyup.twistleAutoCapField");
            }
        });
    };

    $.fn.fadeAndRemove = function(duration, afterRemoveFn) {
        return this.fadeOut(duration || 250, function() {
            $(this).remove();
            if(afterRemoveFn){
                afterRemoveFn();
            }
        });

    };


    $.fn.slideUpAndRemove = function(duration) {
        return this.slideUp(duration, function() {
            $(this).remove();
        });

    };

    //http://stackoverflow.com/a/10835425
    $.fn.removeClassPrefix = function(prefix) {
        this.each(function(i, el) {
            var classes = el.className.split(" ").filter(function(c) {
                return c.lastIndexOf(prefix, 0) !== 0;
            });
            el.className = $.trim(classes.join(" "));
        });
        return this;
    };

    var tagColors = ["#F7977A","#F9AD81","#FDC68A","#C4DF9B","#A2D39C","#82CA9D","#7BCDC8","#6ECFF6","#7EA7D8","#8493CA","#8882BE","#A187BE","#BC8DBF","#F49AC2","#F6989D"];

    $.fn.randomTagColor = function(){
        return this.each(function(){
            var $this = $(this),
                tagCharList = $this.text().toLowerCase().split(""),
                tagCharCodeSum = _.reduce(tagCharList, function(memo, char){ return memo + char.charCodeAt(0); },1),
                colorIndex = (tagCharCodeSum % tagColors.length) || 1;
            $this.css("background-color", tagColors[colorIndex] || tagColors[0]);
        });
    };

    $.fn.scrollToBottom = function(duration, offset, forcePos) {
        var scrollToPos = forcePos || ((this.prop("scrollHeight") ?  (this.prop("scrollHeight") - this.height()) : this.height()) + (offset || 0));
        if(duration) {
            return this.animate({
                scrollTop: scrollToPos
            }, duration);
        }
        return this.scrollTop(scrollToPos);
    };

    $.fn.imagesLoaded = function(callback){
      var elems = this.filter('img'),
          len   = elems.length;
    
      elems.bind('load',function(){
          if (--len <= 0){ callback.call(elems,this); }
      }).each(function(){
         // cached images don't fire load sometimes, so we reset src.
         if (this.complete || this.complete === undefined){
            var src = this.src;
            // webkit hack from http://groups.google.com/group/jquery-dev/browse_thread/thread/eee6ab7b2da50e1f
            // data uri bypasses webkit log warning (thx doug jones)
            this.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
            this.src = src;
         }
      });
    
      return this;
    };
    /**
     * jQuery alterClass plugin
     *
     * Remove element classes with wildcard matching. Optionally add classes:
     *   $( '#foo' ).alterClass( 'foo-* bar-*', 'foobar' )
     *
     * Copyright (c) 2011 Pete Boere (the-echoplex.net)
     * Free under terms of the MIT license: http://www.opensource.org/licenses/mit-license.php
     *
     */
    $.fn.alterClass = function ( removals, additions ) {
    
        var self = this;
    
        if ( removals.indexOf( '*' ) === -1 ) {
            // Use native jQuery methods if there is no wildcard matching
            self.removeClass( removals );
            return !additions ? self : self.addClass( additions );
        }
    
        var patt = new RegExp( '\\s' + 
                removals.
                    replace( /\*/g, '[A-Za-z0-9-_]+' ).
                    split( ' ' ).
                    join( '\\s|\\s' ) + 
                '\\s', 'g' );
    
        self.each( function ( i, it ) {
            var cn = ' ' + it.className + ' ';
            while ( patt.test( cn ) ) {
                cn = cn.replace( patt, ' ' );
            }
            it.className = $.trim( cn );
        });
    
        return !additions ? self : self.addClass( additions );
    };

    // overrides datepicker widget (if present) to use native picker on mobile
    if ($.fn.datepicker && window.App) {

        $.widget("ui.tws_datePicker", {
                _init: function () {
                    var $el = this.element;

                    function checkDateInput() {
                        //https://stackoverflow.com/a/10199306
                        var input = document.createElement('input');
                        input.setAttribute('type','date');

                        var notADateValue = 'not-a-date';
                        input.setAttribute('value', notADateValue);

                        return (input.value !== notADateValue);
                    }

                    if (isHandheld() &&
                        checkDateInput()) {
                        this.useNativeDate = true;
                    }

                    if (this.useNativeDate) {
                        $el.prop("type", "date");
                        if (MobileDevice.any()) {
                            // on true mobile devices, add the `hasDatepicker` which places a little calendar icon into the
                            // input control. If
                            $el.addClass("hasDatepicker");
                        }
                    } else {
                        $el.datepicker(this.options);
                    }
                },
                setDate: function (newDate) {
                    var $el = this.element;
                    if (this.useNativeDate) {
                        $el.get(0).valueAsDate = newDate;
                    }
                    else {
                        $el.datepicker("setDate", newDate);
                    }
                },
                getDateVal: function () {
                    var $el = this.element;
                    if (this.useNativeDate) {
                        var dateValue = this.getDate();
                        return dateValue ? formatParsedDate(dateValue, "{month}/{date}/{year}") : "";
                    }
                    else {
                        return $el.val();
                    }
                },
                getDate: function () {
                    var $el = this.element;
                    if (this.useNativeDate) {
                        var dateVal = $el.get(0).valueAsDate;
                        if (dateVal) {
                            // add the browser's timezone offset (in ms) to get the true "Date" entered
                            return new Date(dateVal.valueOf() + (dateVal.getTimezoneOffset() * 60000));
                        }
                        return null;
                    }
                    else {
                        return $el.datepicker("getDate");
                    }
                }
            }
        );
    }

    /*
     * custom drop down - allows for total control of styling. could probably be improved for longer lists
     * just create it on a ul - (optionally a `placeholder` attribute or data value) - each li becomes part of the pull down)
     * maybe someday we'll support unicorns
     * relies on jquery dialog
     */

    $.widget("ui.twistle_dropdown", {
        _create: function() {
            var context = this;
            var $self = context.element;
            context.dropDownId = new Date().getTime(); // a little unique id that helps w/ unbinding events
            context.enabled = $self.attr("disabled") !== "disabled";
            context.nativeSelect = (App.config.get("isMobile")
                || App.config.get("embeddedDialogMode"));
            context.multiselect = !!$self.data("multiselect") || !!context.options.multiselect;

            context.placeholder = (context.options.placeholder || $self.data("placeholder") ||
                                    $self.attr("placeholder") || "");

            if (context.nativeSelect) {
                var $select = $("<select></select>");
                $self.find("li").each( function(idx,t) {
                    var value = $(t).attr("data-value");
                    var content = $(t).html();

                    $select.append(Mustache.render("<option value='{{value}}'>{{{content}}}</option>", {
                        value: value, content: content
                    }));
                });

                if (context.placeholder === ""){
                    $select.prepend( "<option value=''></option>" );
                }

                $self.append($select);
                $self.find("li").remove();

                $select.prop("selectedIndex", -1); // deselect anything
                $select.bind("change", {
                    context: context
                }, context._selectChanged);
            }
            else{
                context.$panel = $("<ul class='twistle_dropdown_panel' role='listbox'></ul>");

                if (context.options.tappableTargets) {
                    context.$panel.addClass("twistle_dropdown_tappable_targets");
                }

                $self.addClass("twistle_dropdown");
                // if we didn't get it in the markup already
                $self.prop("tabindex", 0);
                // be a good citizen
                context.$panel.prop("tabindex", 0);
                if(context.options.panelClass) {
                    context.$panel.addClass(context.options.panelClass);
                }

                $self.find("li").hoverClass("hovered").bind("click", {
                    context: context
                }, context._menuItemClicked).appendTo(context.$panel);

                context.menuOpen = false;

                var dialogOpts = {
                    autoOpen: false,
                    modal: true,
                    draggable: false,
                    resizable: false,
                    autoResize: true,
                    minHeight: 20,
                    dialogClass: "twistle_dropdown_panel_wrapper",
                    open: function() {
                        context.menuOpen = true;
                        context.$panel.focus();
                        context.$panel.css('min-width', context.element.outerWidth());
                    },

                    close: function() {
                        context.menuOpen = false;
                    }
                };

                if($self.data('width')) {
                    dialogOpts.width = $self.data('width');
                }
                else {
                    dialogOpts.width = $self.width();
                }

                if (context.options.maxHeight) {
                    dialogOpts.maxHeight = context.options.maxHeight;
                }

                context.$panel.hide().dialog(dialogOpts);

                context.$panel.dialog("widget").find(".ui-dialog-titlebar").remove();
                $(window).bind("resize.tws-dropdown-" + context.dropDownId, {
                    context: context
                }, context._reposition);
                $self.bind("click", {
                    context: context
                }, context._menuClicked);
                context.$panel.bind("keydown", {
                    context: context
                }, context._handleTyping);
                $self.bind("keydown", {
                    context: context
                }, context._handleTyping);
            }

            if(context.options.addHiddenField && $self.data('fieldname')) {
                $self.append('<input type="hidden" name="' + $self.data('fieldname') + '" value=""/>');
            }

            var selected = context.options.selected;

            if($self.data('selected') && !selected){
                selected = $self.data('selected');
                if (typeof selected === "string") {
                    selected = selected.trim();
                }
            }

            if(selected) {
                if (context.multiselect && typeof selected === "string") {
                    for (let value of selected.split(",")) {
                        this.selectItem(value);   
                    } 
                } else {
                    this.selectItem(selected);
                }
            }
            else if(!context.nativeSelect) {
                $self.append('<span class="placeholder">' + context.placeholder + '</span>');
            }
        },

        _menuClicked: function(evt) {
            var context = evt.data.context, $self = context.element;
            if(!context.enabled)
            {
                return;
            }
            context.$panel.dialog("open");
            $(".ui-widget-overlay").last().bind("click", {
                context: context
            }, context._hideMenu);
            context._trigger("menuopen");
            if (context.options.position) {
                // allow for overriding position by setting my/at
                context.$panel.dialog("option", "position", {
                    my: context.options.position.my || "left top",
                    at: context.options.position.at || "left bottom",
                    of: $self
                });
            } else {
                context.$panel.dialog("option", "position", {
                    my: "left top",
                    at: "left bottom",
                    of: $self
                });
            }
        },

        // this only gets used if the dropdown is a select
        _selectChanged: function(evt) {
            var context = evt.data.context, $self = context.element;
            var value = $(evt.currentTarget).val();

            if(context.options.addHiddenField) {
                $self.find('input[name=' + context.element.data('fieldname') + ']').val(value);
            }

            context._trigger("itemselected", value);
        },

        _menuItemClicked: function(evt) {
            var context = evt.data.context, $self = context.element, $menuItem = $(evt.currentTarget);
            context._hideMenu(evt);
            context.selectItem($menuItem.data("value"));
            context._trigger("itemselected", $menuItem.data(), $menuItem);
            $self.focus();
        },

        _hideMenu: function(evt) {
            var context = evt.data.context;
            window.setTimeout(function() {
                try
                {
                    context.$panel.dialog("close");
                }
                catch(err)
                {
                    // timing issues cause this to fail ?
                }
            }, 20);

        },

        _handleTyping: function(evt) {
            var context = evt.data.context,
                code = evt.keyCode || evt.which;
            if(_.indexOf([13, 32, 38, 40], code) > -1) {
                var currentHoveredItem;
                var items = context.$panel.find("li");
                if(!context.menuOpen) {
                    context._menuClicked(evt);
                    if(!items.filter(".hovered")) {
                        $(items[0]).addClass("hovered");
                    }
                    evt.stopPropagation();
                }
                else if(_.indexOf([38, 40], code) > -1) {//handle up/down
                    currentHoveredItem = items.filter(".hovered");
                    var currentIndex = currentHoveredItem ? currentHoveredItem.index() : 0;
                    var newIndex;
                    if(code === 38) {
                        newIndex = (currentIndex > 0) ? currentIndex - 1 : (items.length - 1);
                    }
                    if(code === 40) {
                        newIndex = (currentIndex < items.length - 1) ? (currentIndex + 1) : 0;
                    }
                    currentHoveredItem.removeClass("hovered");
                    $(items[newIndex]).addClass("hovered");

                }
                else if(code === 32 || code === 13) {// select an item
                    currentHoveredItem = items.filter(".hovered");
                    currentHoveredItem.trigger("click");
                }
                // someday do - key based filtering
            }

        },

        _reposition: _.debounce(function (evt) {
            if (_.has(evt, "data.context")) {
                var context = evt.data.context;
                if(context.menuOpen)
                {
                    context.$panel.dialog("option", "position", context.$panel.dialog("option", "position"));
                }
            }
        }, 150, false),

        setEnabled: function(enabled){
            var context = this;
            context.enabled = enabled;
            context.element.toggleClass("disabled", !enabled);
        },
        getHiddenInput: function() {
            var context = this,
            $self = context.element;
            if(context.options.addHiddenField) {
                return $self.find('input[name=' + context.element.data('fieldname') + ']');
            }
        },
        getValue: function() {

            var context = this;

            if (context.nativeSelect) {
                return {
                    value: context.element.find("select").val(),
                    name: context.element.find("option:selected").text()
                };
            }

            var $selected = context.$panel.find(".selected");

            if ($selected) {
                var result = $selected.map((index, el) => {
                    return {
                        value: $(el).data("value"),
                        name: $(el).text()
                    };
                });
                return context.multiselect ? result : result[0];
            }
            return undefined;

        },

        // select a list item, using either the data-value or the text value
        selectItem: function(value) {
            var context = this,
            $self = context.element;
            if (context.nativeSelect) {
                $self.find("select").val(value);
                if(context.options.addHiddenField) {
                    $self.find('input[name=' + context.element.data('fieldname') + ']').val(value);
                }
            }
            else{
                if(value !== undefined){
                    context.$panel.find("li").each(function() {
                        var $item = $(this);
                        if($item.data('value') === value || $item.text() === value) {

                            if (context.multiselect) {
                                $item.toggleClass("selected");
                                if($self.data("use-option-ui")) {
                                    $self.html(_.map(context.$panel.find("li.selected"), x => $(x).html()).join(""))
                                } else {
                                    $self.html($item.text());
                                    $self.html(_.map(context.$panel.find("li.selected"), x => $(x).text()).join(","))
                                }
                            } else {
                                context.$panel.find("li.selected").removeClass("selected");
                                $item.addClass("selected");

                                if($self.data("use-option-ui"))
                                {
                                    $self.empty().append($item.clone());
                                }
                                else
                                {
                                    $self.html($item.text());
                                }
                            }

                            if(context.options.addHiddenField) {
                                $self.append('<input type="hidden" name="' + context.element.data('fieldname') + '" value="' + value + '"/>');
                            }
                            return false;
                        }
                    });
                }
                else{
                    $self.html('<span class="placeholder">' + context.placeholder + '</span>');
                    if(context.options.addHiddenField && $self.data('fieldname')) {
                        $self.append('<input type="hidden" name="' + $self.data('fieldname') + '" value=""/>');
                    }
                }
            }
        },

        setFilter:function(value){
            var context = this;
            context.$panel.find("li").each(function() {
                var $item = $(this);
                if($item.data('filters')){
                    var itemIsInFilter = _.include($item.data('filters').split(" "), value) || $item.data('filters') === "*";
                    $item.toggle(itemIsInFilter);
                    if(!itemIsInFilter && $item.hasClass("selected")){
                        context.selectItem(); // change selected value to nothing
                    }
                }
            });
            context.currentFilter = value;
        },
        addItem:function(value, name, filters, selected){
            var context = this, $item, $self = context.element;

            if (context.nativeSelect) {
                $item = $("<option></option>")
                    .prop("value",value)
                    .text(name)
                    .appendTo($self.find("select"));
            }
            else
            {
                $item = $("<li></li>");
                $item.data({"value":value, "filters": filters})
                     .text(name)
                     .hoverClass("hovered")
                     .bind("click", {context: context}, context._menuItemClicked)
                     .appendTo(context.$panel);

                if(context.currentFilter){
                    var itemIsInFilter = _.include($item.data('filters').split(" "), value) || $item.data('filters') === "*";
                    $item.toggle(itemIsInFilter);
                }
            }

            if(selected){
                context.selectItem(value);
            }
            return $item;
        },
        getItemValues: function() {
            var context = this;
            var $self = context.element;

            if (context.nativeSelect) {
                return $.map($self.find("select option"), option => option.value);
            } else {
                return $.map(context.$panel.find("li"), option => $(option).data("value"));
            }
        },
        getItemLabels: function() {
            var context = this;
            var $self = context.element;

            if (context.nativeSelect) {
                return $.map($self.find("select option"), option => option.text);
            } else {
                return $.map(context.$panel.find("li"), option => $(option).text());
            }
        },
        repatriate:function(){
            var context = this;
            var $self = context.element;
            if (context.nativeSelect) {
                // nothing to do
            }
            else
            {
                $self.empty();
                $self.removeAttr("tabindex");
                $self.unbind("click");
                $self.unbind("keydown");
                context.$panel.find("li").unbind("click").appendTo($self);
            }
            context.destroy();
        },

        destroy: function() {
            var context = this;
            $.Widget.prototype.destroy.apply(this, arguments);
            // default destroy
            // now do other stuff particular to this widget
            context.$panel.remove();
            $(window).unbind("resize.tws-dropdown-" + context.dropDownId);
        }

    });

    /**
     * Incredibly simple tab view
     */
    $.widget("ui.twistle_tabs", {
        _create: function() {
            var context = this;
            var $self = context.element;

            $self.find(".tws-tab-bar .tws-tab").hoverClass("hovered").bind("click", {
                context: context
            }, context._tabClicked);

            var selected = context.options.selected;

            if(selected) {
                context.selectTab(selected, true);
            }

        },

        _tabClicked: function(evt) {
            var context = evt.data.context;
            var canChangeCallback = context.options["canChangeTabs"];
            var canChangeTabs = true;

            if (canChangeCallback) {
                canChangeTabs = canChangeCallback();
            }

            if (canChangeTabs) {
                context.selectTab($(evt.currentTarget).data("title"));   
            }
        },

        selectTab: function(tabTitle, isInitialCreation) {
            var context = this;
            var $self = context.element;
            $self.find(".tws-tab-selected").removeClass("tws-tab-selected");
            $self.find(".tws-tab-page-selected").removeClass("tws-tab-page-selected");
            $self.find(".tws-tab-bar .tws-tab[data-title=" + tabTitle + "]").addClass("tws-tab-selected");
            $self.find(".tws-tab-page-wrapper .tws-tab-page[data-title=" + tabTitle + "]").addClass("tws-tab-page-selected");
            context._trigger("tabSelected", null,
                {
                    title: tabTitle,
                    $tab: $self.find(".tws-tab-bar .tws-tab[data-title=" + tabTitle + "]"),
                    isInitialCreation: isInitialCreation
                });
        },

        destroy: function() {
            $.Widget.prototype.destroy.apply(this, arguments);
            // default destroy
            // now do other stuff particular to this widget
        }

    });

    /*
     * Auto-growing textareas; technique ripped from Facebook
     */

    $.widget("ui.twistle_autogrow", {
        // default options
        options: {
            //maxHeight:null,
            //heightChanged:function()
            minHeight: false,
            container: false,
            wrapperClass: "",
            removeBackgroundImageSelector: ".fileElement"

        },
        hasContainer: false,
        _create: function() {
            var $this = this.element, context = this, $thisContainer = null;

            if(context.options.container) {
                $thisContainer = context.options.container;
                context.hasContainer = true;
            }
            else {
                context.options.container = $this;
                $thisContainer = $this;
            }
            if(!context.options.minHeight) {
                context.options.minHeight = $this.height();
            }

            context.shadow = $('<div></div>').css({
                position: 'absolute',
                top: -5000,
                left: -5000,
                border: "2px solid lime",
                background: "#222",
                color: "#fff",
                'z-index': -2000,
                width: $thisContainer.width(),
                fontSize: $thisContainer.css('fontSize'),
                fontFamily: $thisContainer.css('fontFamily'),
                lineHeight: $thisContainer.css('lineHeight'),
                resize: 'none'
            }).addClass(context.options.wrapperClass).appendTo(document.body);

            context.reset(); // Sets the starting min height for the container
            
            $this.bind("keydown.twistle_autogrow keyup.twistle_autogrow input.twistle_autogrow", {
                context: context
            }, context._startUpdateHeightTimer);
            
        },
        _startUpdateHeightTimer: function(evt){
            var context = evt.data.context;
            if(context.updateHeightTimer){
                return;
            }
            context.updateHeightTimer = setTimeout(function(){
                context._updateHeight({
                    data: {
                        context: context
                    }
                });
                context.updateHeightTimer = false;
            },100);

        },
        _updateHeight: function(evt) {
            var context = evt.data.context;
            var shadow = context.shadow;
            var $this = context.element;
            var $thisContainer = context.options.container;
            var originalHeight = context.options.minHeight;
            var currentHeight = $thisContainer.outerHeight();
            var val = $thisContainer.clone();

            if(context.hasContainer) {
                val.css("height", "");
                shadow.html(val);
                val.find(context.options.removeBackgroundImageSelector).css("background-image", "");
                $thisContainer.find("textarea").each(function(i, field) {
                    context._replaceField(shadow, field);
                });

            }
            else {
                shadow.html("<textarea name='" + $this.attr("name") + "'></textarea>");
                context._replaceField(shadow, $this);
            }

            var newHeight;
            if( context.options.maxHeight !== undefined) {
                newHeight = Math.min(context.options.maxHeight, Math.max(shadow.height(), originalHeight));
            }
            else {
                newHeight = Math.max(shadow.height(), originalHeight);
            }

            if(context.hasContainer) {
                // possibly change height of textarea
                let newTextHeight = Math.max(shadow.find("div[title=" + $this.attr('id') + "]").height()+7,
                    context.options.minHeight);
                if(newTextHeight !== $this.height()){
                    $this.height(newTextHeight);
                    $("." + context.options.wrapperClass).scrollTop(5000); // scroll to bottom after setting the height
                }
            }
            
            newHeight += 10;
            if(newHeight !== currentHeight){
                $thisContainer.height(newHeight);
                context._trigger("heightChanged");
            }
        },

        _replaceField: function(shadow, field) {
            var context = this, $field = $(field), content = $field.val().replace(/&/g, '&amp;').replace(/ {2}/g, '&nbsp;').replace(/<|>/g, '&gt;').replace(/\n/g, '<br />:');

            var replacement = $('<div title="' + $field.attr("id") + '" class="tws-clear-both">' + content + '</div>');
            replacement.css({
                width: $field.css("width"),
                fontSize: $field.css("font-size"),
                fontFamily: $field.css("font-family"),
                lineHeight: $field.css('lineHeight'),
                wordWrap: "break-word",
                whiteSpace: 'pre-wrap'
            });

            shadow.find("textarea[name='" + $field.attr("name") + "']").replaceWith(replacement);

            if(replacement.height() < context.options.minHeight) {
                replacement.height(context.options.minHeight);
            }

        },

        height: function() {
            var context = this, $this = context.element;
            return $this.height();
        },

        reset: function() {
            var context = this, $thisContainer = context.options.container;
            //reset the width of the shadow/measurement area
            context.shadow.css("width", $thisContainer.width());
            context._updateHeight({
                data: {
                    context: context
                }
            });
        },

        destroy: function() {
            var $this = this.element, context = this;
            $this.unbind("keydown.twistle_autogrow keyup.twistle_autogrow");
            context.shadow.remove();
            $.Widget.prototype.destroy.apply(this, arguments);
            // default destroy
            // now do other stuff particular to this widget
        }

    });


    $.widget("ui.twistle_person_ac", {
        // wraps a JQUI autocomplete with configure twistle person lookup
        options: {
            valueAttribute: "username", // when asking for the selected value, what do you want out of the contact?
            accounttype: "ur",
            per_page: 5,
            org_ids: "", // comma sep list
            relationships: "" // comma sep list
        },

        _create: function()
        {
            var $this = this.element,
                context = this;

            context.contactLookupList = new ContactList();
            context.contactLookupList.fetchFromServer = true;

            $this.autocomplete({
                source: function( request, response ) {
                    var fetchParams = {
                        term: request.term,
                        include_network:true,
                        include_self:true,
                        accounttype:context.options.accounttype || "ur",
                        per_page:context.options.per_page || 5,
                        org_ids:context.options.org_ids || "",
                        relationships:context.options.relationships || ""
                    };

                    context.contactLookupList.fetch({
                            reset:true,
                            data:$.param(fetchParams),
                            params:fetchParams,
                            success:function(){
                                var respData = [];
                                context.contactLookupList.each(function(contact){
                                    // we should also filter results here - as they might have come direct from the server
                                    respData.push({
                                                label: contact.get("formalname"),
                                                value: contact.get(context.options.valueAttribute || "username")
                                            });
                                });
                                response( respData );
                            }
                        });
                    },
                    minLength: 0,
                    select: function( event, ui ) {
                        $(this).val(ui.item.label);
                        context.chosenItem = ui.item;
                        event.preventDefault();
                        return false;
                    },
                    focus: function( event, ui ) {
                        return false;
                    }
            });
        },

        chosenValue: function(){
            return (this.chosenItem && this.chosenItem.value) || ""; // can't return undefined - caller gets the $ui
        },

        destroy: function()
        {
            // do we need to do anything specific to the wrapped autocomplete?
            $.Widget.prototype.destroy.apply(this, arguments);
        }
    });

    // modify JQ dialog so it allows interaction with select2
    // https://api.jqueryui.com/dialog/#method-_allowInteraction
    $.widget( "ui.dialog", $.ui.dialog, {
        _allowInteraction: function(e) {
            if ($(e.target).closest('.select2-dropdown').length) {
                return true;
            }
            return this._super(e);
        }
    });

}($));
